/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon16Solid = forwardRef('TechPowerButtonIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.125 1.15a1.125 1.125 0 0 0-2.25 0V6.9a1.125 1.125 0 0 0 2.25 0V1.15Z" }),
        React.createElement("path", { d: "M4.757 4.36A1.125 1.125 0 1 0 3.26 2.68a7.125 7.125 0 1 0 9.49.01 1.125 1.125 0 1 0-1.5 1.677 4.875 4.875 0 1 1-6.493-.007Z" })));
});
